import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";

function App() {
  useEffect(() => {
    // Light theme only
    document.documentElement.classList.remove("dark");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(10,10,10,0.12)",
            color: "#0a0a0a",
          },
        }}
      />
    </div>
  );
}

export default App;
